function stripTags(html) {
  return String(html || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function slugifyHeading(text, used) {
  let base = stripTags(text)
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 72);
  if (!base) base = 'section';
  let id = base;
  let n = 2;
  while (used.has(id)) {
    id = `${base}-${n}`;
    n += 1;
  }
  used.add(id);
  return id;
}

/**
 * Inject stable ids on h2/h3 and build TOC entries from blog HTML (TipTap output).
 * @param {string} html
 * @returns {{ html: string, entries: { id: string, text: string, level: number }[] }}
 */
export function prepareJournalArticleHtml(html) {
  const raw = String(html || '');
  if (!raw.trim()) return { html: '', entries: [] };

  const used = new Set();
  const entries = [];

  const processed = raw.replace(/<h([2-3])(\s[^>]*)?>([\s\S]*?)<\/h\1>/gi, (match, levelStr, attrs, inner) => {
    const text = stripTags(inner);
    if (!text) return match;
    const level = Number(levelStr);
    const attrStr = attrs || '';
    let id = null;
    const idMatch = attrStr.match(/\bid\s*=\s*["']([^"']+)["']/i);
    if (idMatch?.[1]) {
      id = idMatch[1];
    } else {
      id = slugifyHeading(text, used);
    }
    used.add(id);
    entries.push({ id, text, level });
    if (idMatch?.[1]) return match;
    return `<h${levelStr}${attrStr} id="${id}">${inner}</h${levelStr}>`;
  });

  return { html: processed, entries };
}
